import type { ID } from "types";
import { ApiRoutes } from "consts/enpoints/api";
import { fetchApi } from "infrastructure/api";
import type { PspKycSettingCreatePayload } from "./types";

export const getPspKycSettings = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetPspKycSettings}${queryString}`);

export const getPspKycSettingById = (coreId: ID) =>
    fetchApi(ApiRoutes.GetPspKycSetting(coreId));

export const createPspKycSetting = (body: PspKycSettingCreatePayload) =>
    fetchApi(ApiRoutes.PostPspKycSetting, {
        method: 'POST',
        body
    });

export const deletePspKycSetting = (coreId: ID) =>
    fetchApi(ApiRoutes.DeletePspKycSetting(coreId), {
        method: 'DELETE'
    });
